export default __webpack_public_path__ + "static/media/hero_footer.32e2f7d9.webp";